export const isDev =
  !process.env.REACT_APP_ENV ||
  process.env.REACT_APP_ENV === 'DEV' ||
  process.env.REACT_APP_ENV === 'CI';
